import { render } from "./calendarAgenda.vue?vue&type=template&id=23186e89&scoped=true"
import script from "./calendarAgenda.vue?vue&type=script&lang=js"
export * from "./calendarAgenda.vue?vue&type=script&lang=js"

import "./calendarAgenda.vue?vue&type=style&index=0&id=23186e89&lang=scss&scoped=true"
import "./calendarAgenda.vue?vue&type=style&index=1&id=23186e89&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23186e89"]])

export default __exports__